module.exports = __webpack_public_path__ + "assets/dades-min.9f442106de6d3e679c2e0a85b4c0de7d.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/Valeri/dades-min.jpg
 ** module id = 412
 ** module chunks = 0
 **/